import React from "react";

import { ClientQuarterPipeline } from "@/hooks/api/generated";

export function QuarterCardEmpty({
  quarter,
}: {
  quarter: ClientQuarterPipeline;
}): JSX.Element {
  return (
    <div className="w-full h-[302px] bg-[#F9FAFB] rounded-[10px] outline outline-1 outline-[#D1D5DC] outline-offset-[-1px] inline-flex flex-col justify-center items-center gap-3">
      <div className="w-[67.11px] h-6 relative">
        <div className="absolute top-[-1px] left-[1px] text-center text-[#0A0A0A] text-base font-normal leading-6">
          {quarter.quarter}
        </div>
      </div>
      <div className="w-[108.62px] h-5 relative">
        <div className="absolute top-[-0.5px] left-0 text-center text-[#6A7282] text-sm font-normal leading-5">
          Data not available
        </div>
      </div>
    </div>
  );
}
